import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"
import { Button, Stack, Tooltip, Typography } from "@mui/material"

export default function InputFilePDF({ label, icon, value, setValue }) {
	const fileChange = (e) => {
		const files = e.target.files
		if (files.length === 0) setValue(null)
		else setValue(files[0])
	}

	return (
		<Stack spacing={2} alignItems="center" sx={{ width: "100%" }}>
			<Button startIcon={icon} variant="contained" fullWidth component="label">
				{label}
				<input type="file" hidden onChange={fileChange} accept=".pdf" />
			</Button>

			{value?.name && (
				<Tooltip title={value.name}>
					<Stack
						direction="row"
						alignItems="center"
						sx={{
							maxWidth: "100%",
							overflow: "hidden",
						}}
						spacing={1}
					>
						<InsertDriveFileIcon fontSize="small" />

						<Typography variant="body2" noWrap sx={{ textOverflow: "ellipsis" }}>
							{value.name}
						</Typography>
					</Stack>
				</Tooltip>
			)}
		</Stack>
	)
}
